import { render, staticRenderFns } from "./UserContractUserList.vue?vue&type=template&id=08bc8038"
import script from "./UserContractUserList.vue?vue&type=script&lang=js"
export * from "./UserContractUserList.vue?vue&type=script&lang=js"
import style0 from "./UserContractUserList.vue?vue&type=style&index=0&id=08bc8038&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports